import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsRoutingModule } from './notifications-routing.module';
import { BellNotificationsComponent } from './page/bell-notifications/bell-notifications.component';
import { LaaSSharedModule } from 'src/app/shared/laas-shared.module';
import { BellNotificationsContentComponent } from './page/bell-notifications-content/bell-notifications-content.component';

@NgModule({
  declarations: [
    BellNotificationsComponent,
    BellNotificationsContentComponent
  ],
  imports: [
    CommonModule,
    NotificationsRoutingModule,
    LaaSSharedModule
  ]
})
export class NotificationsModule { }
